import {
  isVigenteLayout,
  readLayoutSections,
  readLayoutUnsectioned,
} from './shouldRenderTaskField';

export const EXTRA_ATTACHMENTS_FIELD_NAME = 'DownloadDealExtraAttachments';
const OFFICIAL2_FIELD_NAME = 'DownloadDealBuyOrderOfficial2';

const extraAttachmentsLayoutField = {
  name: EXTRA_ATTACHMENTS_FIELD_NAME,
  label: 'Anexos Extras',
};

function fieldNameOf(field) {
  return field?.name ?? field?.Name;
}

function listHasField(fields, fieldName) {
  return (fields ?? []).some((field) => fieldNameOf(field) === fieldName);
}

function insertAfterAnchor(fields, anchorName, item) {
  const index = (fields ?? []).findIndex((field) => fieldNameOf(field) === anchorName);
  if (index < 0) {
    return null;
  }

  const next = fields.slice();
  next.splice(index + 1, 0, item);
  return next;
}

function layoutAlreadyHasExtraAttachments(unsectioned, sections) {
  if (listHasField(unsectioned, EXTRA_ATTACHMENTS_FIELD_NAME)) {
    return true;
  }

  return sections.some((section) =>
    listHasField(section.fields ?? section.Fields, EXTRA_ATTACHMENTS_FIELD_NAME)
  );
}

export default function placeExtraAttachmentsInLayout(fieldLayout) {
  if (!isVigenteLayout(fieldLayout)) {
    return fieldLayout;
  }

  const unsectioned = readLayoutUnsectioned(fieldLayout);
  const sections = readLayoutSections(fieldLayout);
  if (layoutAlreadyHasExtraAttachments(unsectioned, sections)) {
    return fieldLayout;
  }

  const unsectionedWithField = insertAfterAnchor(
    unsectioned,
    OFFICIAL2_FIELD_NAME,
    extraAttachmentsLayoutField
  );
  if (unsectionedWithField) {
    return { ...fieldLayout, unsectioned: unsectionedWithField };
  }

  let insertedInSection = false;
  const sectionsWithField = sections.map((section) => {
    const fields = section.fields ?? section.Fields ?? [];
    const fieldsWithExtra = insertAfterAnchor(
      fields,
      OFFICIAL2_FIELD_NAME,
      extraAttachmentsLayoutField
    );
    if (!fieldsWithExtra) {
      return section;
    }

    insertedInSection = true;
    return { ...section, fields: fieldsWithExtra };
  });

  if (!insertedInSection) {
    return fieldLayout;
  }

  return { ...fieldLayout, sections: sectionsWithField };
}
